<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">CEU Assessment</h3>

      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->

  <div #questionContainer class="card-body" style="">
    <div class="participant-list" style="">
      <div>
        <div *ngIf="ceuError" class="alert alert-danger">{{ ceuError }}</div>
        <div class="text-center my-auto" *ngIf="completionStatus && completionStatus.metCEUCriteria">
          <h3>Course Complete!</h3>
          <h6>You can download you certificate from <a [routerLink]="['account/ceus']" (click)="activeModal.close()">CEU History</a> in "My Account"</h6>
          <a role="button" class="btn btn-sm btn-instagram" href="javascript:void(0)" (click)="activeModal.close()">Done</a>
        </div>
        <div class="text-center my-auto" *ngIf="notRegistered">
          <h3>Not registered</h3>
          <h6>You do not have a registration for this event, so you can't earn CEUs. If you think this is error, please contact support.</h6>
          <a role="button" class="btn btn-sm btn-instagram" href="javascript:void(0)" (click)="activeModal.close()">Done</a>
        </div>
        <ng-container *ngIf="completionStatus && !completionStatus.metCEUCriteria">
          <form [formGroup]="assessmentForm" novalidate>
            <div formArrayName="questions">
              <div *ngFor="let question of assessment.questions; let idx = index">
                <div *ngIf="idx == currentQuestion" [formGroupName]="idx">
                  <h6><strong>Question {{ idx + 1 }}: {{ question.text }}</strong></h6>
                  <div class="ml-3 form-check" *ngFor="let answer of question.answers; let idx2 = index">
                    <input class="form-check-input" type="radio" formControlName="responseId" id="exampleRadios{{ idx2 }}" value="{{ answer.id }}" />
                    <label class="form-check-label" for="exampleRadios{{ idx2 }}">
                      {{ answer.text }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="currentQuestion == assessment.questions.length">
              <label for="messageTextArea">Leave Feedback</label>
              <div class="form-group">
                <star-rating formControlName="rating"></star-rating>
                <div class="invalid-message">
                  <div>Please provide a star rating</div>
                </div>
              </div>

              <div class="form-group">
                <textarea id="messageTextArea" class="form-control" style="transform: translateZ(0px)" placeholder="Feedback Text" formControlName="text"></textarea>
                <div class="invalid-message">
                  <div>Feedback Text is required</div>
                </div>
              </div>
            </div>
          </form>
        </ng-container>
      </div>
      <div *ngIf="completionStatus && !completionStatus.metCEUCriteria" class="mt-2">

        <button type="button" class="btn btn-sm btn-warning float-left mr-2" *ngIf="currentQuestion > 0" (click)="currentQuestion = currentQuestion - 1">Previous</button>
        <button type="button" class="btn btn-sm btn-warning float-right mr-2" *ngIf="currentQuestion < assessment.questions.length" (click)="currentQuestion = currentQuestion + 1">Next</button>
        <button type="button" class="btn btn-sm btn-success float-right mr-2" *ngIf="currentQuestion == assessment.questions.length" (click)="submitAssessment()">Submit</button>
      </div>
    </div>
  </div>

  <!-- End Footer -->
</div>
